import { useGetBuyerDetails } from '@/hooks/buyers/useGetBuyerDetails';
import { buyerDetailsResponseToBuyerProfileUi } from '@/hooks/buyers/useGetBuyerDetails/mapper';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { BuyerProfileUi, initialState } from './BuyerProfileUi';

export function useBuyerProfileViewController() {
  const { buyerId } = useParams();
  const [uiState, setUiState] = useImmer<BuyerProfileUi>(initialState);
  const getBuyerDetailsHook = useGetBuyerDetails(buyerId);

  useEffect(() => {
    const buyerDetailsData = getBuyerDetailsHook.data;
    if (!buyerDetailsData) return;
    setUiState(buyerDetailsResponseToBuyerProfileUi(buyerDetailsData));
  }, [getBuyerDetailsHook.data]);

  const onMoreOptionSelected = (index: number) => {
    if (index === 0) {
      setUiState((draft) => {
        draft.assignKamOpen = true;
      });
    }
  };

  const closeAssignKamDialog = () =>
    setUiState((draft) => {
      draft.assignKamOpen = false;
    });

  return {
    uiState: {
      ...uiState,
      buyerId,
    },
    actions: {
      onMoreOptionSelected,
      closeAssignKamDialog,
    },
  };
}
